import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div className="pt-32 pb-24" data-testid="about-page">
      <section className="container-x max-w-4xl">
        <div className="kicker mb-3">The Atelier</div>
        <h1 className="font-display text-5xl md:text-7xl leading-tight">A boutique for <em className="not-italic gold-text">obsessive listeners.</em></h1>
        <p className="mt-8 text-white/70 text-lg leading-relaxed">Batra Electronics opened its doors on Dispensary Road, Dehradun in 1985 — with a single conviction that a cinema at home should feel like a private opera house, not an electronics showroom. Four decades on, we remain a family-run atelier: authorised distributors of Klipsch, KEF, Marantz, SVS and other reference audio houses, hand-crafting theatres for discerning listeners across the North.</p>
      </section>
      <section className="container-x mt-20 grid md:grid-cols-2 gap-4">
        {[
          { t: "40+", d: "Years crafting reference rooms" },
          { t: "16", d: "Authorised premium brands" },
        ].map((s) => (
          <div key={s.t} className="card-luxury p-10 text-center">
            <div className="font-display text-6xl gold-text">{s.t}</div>
            <div className="mt-3 text-sm text-white/50 uppercase tracking-[0.2em]">{s.d}</div>
          </div>
        ))}
      </section>
      <section className="container-x mt-20 grid lg:grid-cols-2 gap-10 items-center">
        <div className="aspect-[4/3] rounded-3xl overflow-hidden">
          <img src="https://images.unsplash.com/photo-1587023705107-290e07a2355a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85" alt="Showroom" className="w-full h-full object-cover" />
        </div>
        <div>
          <div className="kicker mb-3">Philosophy</div>
          <h2 className="font-display text-3xl md:text-4xl">Precision. Restraint. <em className="not-italic gold-text">Presence.</em></h2>
          <p className="mt-6 text-white/60 leading-relaxed">We measure every room before we design one. Every speaker is chosen for the space it will live in, every component calibrated to the last dB. The result is a room that disappears — leaving only music, and cinema, and you.</p>
          <Link to="/contact" className="btn-gold mt-8">Visit the Showroom <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </div>
  );
}
